//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  DEAL_PLACEHOLDER_IMG,
  BLACK_FRIDAY_SLUG,
  BLACK_FRIDAY_PARTICIPATION_SLUG,
  SUMO_DAY_SLUG,
  SUMO_DAY_PARTICIPATION_SLUG,
} from '@/constants/global';
import get from 'lodash/get';
import BlackFridayBadge from '~/static/campaigns/black-friday-badge.svg?inline';
import SumoDayBadge from '~/static/sumoday-badge.svg?inline';

export default {
  components: {
    BlackFridayBadge,
    SumoDayBadge,
  },
  filters: {
    fullstop(value) {
      if (!value) {
        return '';
      }

      if (value && value.length && value.substr(-1, 1) === '.') {
        return value;
      }

      return `${value}.`;
    },
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    deals: {
      type: Array,
      required: true,
    },
    more: {
      type: String,
      required: true,
    },
    component: {
      type: Object,
      required: true,
    },
  },
  computed: {
    lazyPlaceholderImage() {
      return DEAL_PLACEHOLDER_IMG;
    },
    carouselOptions() {
      return {
        prevNextButtons: true,
        adaptiveHeight: true,
      };
    },
    isPromo() {
      return !!this.component.background;
    },
    campaigns() {
      if (this.$store && this.$store.getters) {
        return this.$store.getters.campaigns || [];
      }
      return [];
    },
  },
  methods: {
    backgroundClick(e) {
      if (e.target.nodeName.toLowerCase() !== 'a') {
        window.location = this.more;
      }
    },
    generateCardDescription(deal) {
      return get(deal, 'card_description');
    },
    isBlackFriday(deal) {
      const isCampaignActive = this.campaigns.includes(BLACK_FRIDAY_SLUG);
      return isCampaignActive && !!deal?.participation?.includes(BLACK_FRIDAY_PARTICIPATION_SLUG);
    },
    isSumoDay(deal) {
      const isCampaignActive = this.campaigns.includes(SUMO_DAY_SLUG);
      return isCampaignActive && !!deal?.participation?.includes(SUMO_DAY_PARTICIPATION_SLUG);
    },
  },
};
